function ReviewRulesCtrl(ReviewRulesService, ShopifyMappingService, $scope, $auth, $state, $location, $stateParams, AppSettings, AdminService, toaster, $rootScope, CommonService) {
  'ngInject';

  const vm = this;
  vm.addRulesForm = {};
  vm.accountArray = [];
  vm.rollingPeriod = [1, 3, 6, 12];
  vm.adminState = false;
  vm.orgId = !$stateParams.orgId ? 3 : $stateParams.orgId;
  vm.saveFormatData = {};
  vm.staticRules = {};
  vm.loading = false;
  vm.loadMoreAccounts = {
    page: 1,
    size: 25,
    loading: false,
    search: ''
   };

  vm.init = function () {
    vm.loading = true;
    vm.aState = 'user.admin.reviewRules';
    if ($state.current.name == vm.aState) {
      vm.adminState = true;
      $rootScope.organizationNameView = false;

      ReviewRulesService.getAccounts(vm.loadMoreAccounts, function (response) {
        if (response.status == 200) {
          vm.accountArray = response.data;
          ReviewRulesService.getReviewRules(function (response) {
            if (response.status == 200) {
              vm.loading = false;
              vm.addRulesForm = vm.setRulesForm(response.data);
              vm.staticRules = response.data.static_rules;
            }
          });
        }
      });
    } else {
      ShopifyMappingService.getAccounts(vm.orgId, function (response) {
        if (response.status == 200) {
          vm.accountArray = response.data;
          ReviewRulesService.getAndiReviewRules(vm.orgId, function (response) {
            if (response.status == 200) {
              vm.loading = false;
              vm.addRulesForm = vm.setRulesForm(response.data);
              vm.staticRules = response.data.static_rules;
            }
          });
        }
      });
    }
  };

  vm.saveReviewRules = function () {
    vm.saveFormat(vm.addRulesForm);
    if (vm.adminState) {
      ReviewRulesService.updateReviewRules(vm.saveFormatData, function (response) {
        if (response.status >= 200 && response.status < 300) {
          toaster.pop('info', "Review rules added successfully");
        }
        else {
          toaster.pop('error', CommonService.throwError(response));
        }
        vm.addRulesForm = vm.setRulesForm(response.data);
      });
    } else {
      ReviewRulesService.saveAndiReviewRules(vm.orgId, vm.saveFormatData, function (response) {
        if (response.status >= 200 && response.status < 300) {
          toaster.pop('info', "Review rules added successfully");
        }
        else {
          toaster.pop('error', CommonService.throwError(response));
        }
        vm.addRulesForm = vm.setRulesForm(response.data);
      });
    }
  };

  vm.clearForm = function () {
    vm.init();
  };

  vm.refreshAccountList = function(searchedAccount){
    if (vm.adminState) {
      vm.loadMoreAccounts = {
        page: 1,
        size: 25,
        search: searchedAccount
      };
      ReviewRulesService.getAccounts(vm.loadMoreAccounts, function (response) {
        vm.loadMoreAccounts.loading = false;
        if (response.status >= 200 && response.status < 300) {
          vm.accountArray = response.data;
        }
      });
    }
  };

  vm.loadMoreAccountList = function(search) {
    if(vm.adminState && !vm.loadMoreAccounts.loading && (vm.accountArray.length / vm.loadMoreAccounts.page) >=  vm.loadMoreAccounts.page ){
      vm.loadMoreAccounts.loading = true;
      vm.loadMoreAccounts.search = search ? search : '';
      vm.loadMoreAccounts.page = vm.loadMoreAccounts.page + 1;
      ReviewRulesService.getAccounts(vm.loadMoreAccounts, function (response) {
        vm.loadMoreAccounts.loading = false;
        if(response.status >= 200 && response.status < 300) {
          vm.accountArray =  vm.accountArray.concat(response.data);
        }
      });
    }
  };

  vm.saveFormat = function (addRulesForm) {
    vm.saveFormatData = {
      account_transaction: {},
      balance_sheet: {
        inventory:
        {
          red: addRulesForm.balance_sheet.inventory.red,
          yellow: addRulesForm.balance_sheet.inventory.yellow
        },
        liability: {
          red: addRulesForm.balance_sheet.liability.red,
          yellow: addRulesForm.balance_sheet.liability.yellow
        },
        depreciation_account_name: addRulesForm.balance_sheet.depreciation_account_name.name,
        asset_offset_account_codes: vm.getCodesFromAccounts(addRulesForm.balance_sheet.asset_offset_account_codes),
        loan_interest_account_codes: vm.getCodesFromAccounts(addRulesForm.balance_sheet.loan_interest_account_codes)
      },
      bank_transaction: {},
      bill: {},
      cross_check: {
        amazon: {
          red: addRulesForm.cross_check.amazon.red
        },
        shopify: {
          red: addRulesForm.cross_check.shopify.red
        }
      },
      income_statement: {
        revenue:
        {
          red: addRulesForm.income_statement.revenue.red,
          yellow: addRulesForm.income_statement.revenue.yellow
        },
        cogs: {
          red: addRulesForm.income_statement.cogs.red,
          yellow: addRulesForm.income_statement.cogs.yellow
        },
        rolling_avg_period: addRulesForm.income_statement.rolling_avg_period
      },
      invoice: {},
      owner_contribution: { account_codes: vm.getCodesFromAccounts(addRulesForm.owner_contribution.account_codes), transaction: { yellow: addRulesForm.owner_contribution.transaction.yellow } },
      owner_distribution: { account_codes: vm.getCodesFromAccounts(addRulesForm.owner_distribution.account_codes), transaction: { yellow: addRulesForm.owner_distribution.transaction.yellow } }
    };
  };

  vm.setRulesForm = function (responseData) {
    if (responseData.balance_sheet) {
      var codeContainer = [];
      codeContainer = vm.accountArray.filter(function (d) { return responseData.balance_sheet['asset_offset_account_codes'].includes(d.code); });
      responseData.balance_sheet['asset_offset_account_codes'] = vm.removeDuplicates(codeContainer,
        responseData.balance_sheet['asset_offset_account_codes']);
      codeContainer = vm.accountArray.filter(function (d) { return responseData.balance_sheet['loan_interest_account_codes'].includes(d.code); });
      responseData.balance_sheet['loan_interest_account_codes'] = vm.removeDuplicates(codeContainer,
        responseData.balance_sheet['loan_interest_account_codes']);
      codeContainer = vm.accountArray.filter(function (d) { return responseData.owner_contribution['account_codes'].includes(d.code); });
      responseData.owner_contribution['account_codes'] = vm.removeDuplicates(codeContainer,
        responseData.owner_contribution['account_codes']);
      codeContainer = vm.accountArray.filter(function (d) { return responseData.owner_distribution['account_codes'].includes(d.code); });
      responseData.owner_distribution['account_codes'] = vm.removeDuplicates(codeContainer,
        responseData.owner_distribution['account_codes']);
      responseData.balance_sheet['depreciation_account_name'] = vm.accountArray.find(function (d) { return d.name == responseData.balance_sheet['depreciation_account_name']; });
    }
    return responseData;
  };

  vm.getCodesFromAccounts = function(accounts){
    return accounts.map(function(d){return d.code});
  };

  vm.removeDuplicates = function (filteredArray, codes) {
    vm.resultArray = [];
    codes.forEach(code => {
      vm.resultArray.push(filteredArray.find(a => a.code == code));
    });
    return vm.resultArray;
  };

}
export default {
  name: 'ReviewRulesCtrl',
  fn: ReviewRulesCtrl
};
